<template>
  <v-app id="inspire" class="signup-info-white">
    <v-container>
      <!--BEGIN Sign Up form version 2-->
      <v-card flat class="mx-auto my-10 signup--form">
        <v-card-text>
          <v-row>
            <!--BEGIN auth instructions-->
            <v-col
              cols="12"
              md="6"
              sm="12"
              class="column-poster sign-up-instructions"
            >
              <v-img
                class="eligibility-poster"
                src="../../../assets/images/kiseb-poster.jpg"
              />
            </v-col>
            <!--END auth instructions-->
            <v-col cols="12" md="6" sm="12">
              <div class="text-center ma-4 logo">
                <Logo height="150" />
                <v-divider />
              </div>
              <div class="text-center">
                <p class="ma-4 pa-4">KISEB ACCOUNT CREATION</p>
              </div>
              <v-form class="mt-2" ref="SignupForm" v-model="isValid">
                <v-row>
                  <v-col cols="12" md="12" sm="12">
                    <v-text-field
                      :rules="rules.field"
                      v-model="formData.firstName"
                      label="First Name"
                      persistent-placeholder
                      placeholder="Enter your First Name"
                      prepend-inner-icon="account_circle"
                      clearable
                      outlined
                      dense
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12" sm="12" class="mt-n4">
                    <v-text-field
                      :rules="rules.field"
                      v-model="formData.lastName"
                      label="Last Name"
                      persistent-placeholder
                      placeholder="Enter your Last Name"
                      prepend-inner-icon="account_circle"
                      clearable
                      outlined
                      dense
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12" sm="12" class="mt-n4">
                    <v-text-field
                      :rules="rules.email"
                      v-model="formData.email"
                      label="Email"
                      placeholder="Email"
                      persistent-placeholder
                      prepend-inner-icon="email"
                      clearable
                      outlined
                      dense
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12" sm="12" class="mt-n4">
                    <vue-tel-input-vuetify
                      required
                      outlined
                      default-country="KE"
                      label="Phone Number"
                      dense
                      mode="international"
                      success="success"
                      hint="Select country code to proceed"
                      v-model="formData.phoneNo"
                      :rules="rules.phone"
                    ></vue-tel-input-vuetify>
                  </v-col>
                  <v-col cols="12" md="12" sm="12" class="mt-n4">
                    <v-text-field
                      v-model="formData.id_number"
                      :rules="rules.id_number"
                      label="ID/ Passport No."
                      placeholder="Enter National ID / Passport  No"
                      dense
                      outlined
                      persistent-placeholder
                      prepend-inner-icon="assignment"
                      clearable
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" md="12" sm="12" class="mt-n4">
                    <v-text-field
                      label="Password"
                      placeholder="Enter Password"
                      outlined
                      dense
                      required
                      @copy.prevent
                      @paste.prevent
                      id="password"
                      @input="checkPassword"
                      persistent-placeholder
                      prepend-inner-icon="vpn_key"
                      v-model="formData.password"
                      :type="showPassword ? 'text' : 'password'"
                      :rules="rules.pwdRules"
                      autocomplete="off"
                    >
                      <template v-slot:append>
                        <v-btn @click="showPassword = !showPassword" icon>
                          <v-icon>{{
                            showPassword ? "visibility" : "visibility_off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:message="{}">
                        <ul class="my-1">
                          <li
                            v-bind:class="{
                              is_valid: contains_eight_characters,
                            }"
                          >
                            At least 8 Characters long
                          </li>
                          <li
                            v-bind:class="{
                              is_valid: contains_max_sixteen_characters,
                            }"
                          >
                            Password should not be longer than 16 characters
                          </li>
                          <li v-bind:class="{ is_valid: contains_number }">
                            Contains Number
                          </li>
                          <li v-bind:class="{ is_valid: contains_uppercase }">
                            Contains Uppercase
                          </li>
                          <li v-bind:class="{ is_valid: contains_lowercase }">
                            Contains Lowercase
                          </li>
                          <li
                            v-bind:class="{
                              is_valid: contains_special_character,
                            }"
                          >
                            Contains Special Character
                          </li>
                        </ul>
                        <div
                          class="checkmark_container"
                          v-bind:class="{ show_checkmark: valid_password }"
                        >
                          <svg width="50%" height="50%" viewBox="0 0 140 100">
                            <path
                              class="checkmark"
                              v-bind:class="{ checked: valid_password }"
                              d="M10,50 l25,40 l95,-70"
                            />
                          </svg>
                        </div>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" md="12" sm="12" class="mt-n4">
                    <v-text-field
                      label="Confirm Password"
                      placeholder="Confirm Password"
                      outlined
                      dense
                      @copy.prevent
                      @paste.prevent
                      id="confirmPassword"
                      required
                      persistent-placeholder
                      prepend-inner-icon="vpn_key"
                      :type="showPassword ? 'text' : 'password'"
                      v-model="formData.confirmPassword"
                      :rules="rules.pwdConfirm"
                    >
                      <template v-slot:append>
                        <v-btn @click="showPassword = !showPassword" icon>
                          <v-icon>{{
                            showPassword ? "visibility" : "visibility_off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <div>
                      <v-btn
                        block
                        class="primary sign-up-button"
                        @click="signup"
                        >Sign Up</v-btn
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
          <div class="ma-5 pa-5">
            <v-divider />
            <div class="pa-5 text-center">
              <v-row>
                <v-col cols="12" md="6" sm="12">
                  <a
                    href="https://kiseb.or.ke/sites/default/files/KISEB/docs/Application%20Procedure.pdf"
                    target="_blank"
                    class="text-decoration-none"
                    >Need help making an application?</a
                  >
                </v-col>
                <v-divider vertical class="divider" />
                <v-col cols="12" md="6" sm="12">
                  <router-link
                    class="text-decoration-none"
                    :to="{ name: 'SignIn' }"
                    >Already a Student?</router-link
                  >
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-container>
  </v-app>
</template>
<script>
import Logo from "../../dashboard/components/Logo.vue";

export default {
  name: "signupComponent",
  components: {
    Logo,
  },
  data: function () {
    return {
      contains_eight_characters: false,
      contains_max_sixteen_characters: false,
      contains_number: false,
      contains_uppercase: false,
      contains_lowercase: false,
      contains_special_character: false,
      valid_password: false,
      formData: {
        username: "",
        firstName: "",
        lastName: "",
        id_number: "",
        phoneNo: "",
        email: "",
        password: "",
        confirmPassword: "",
        programme: "",
      },
      isValid: false,
      showPassword: false,
    };
  },
  computed: {
    setupProgrammes() {
      return this.$store.getters["Application/appGetters"]("setupProgrammes");
    },
    company() {
      return this.$store.getters["Landing/company"];
    },
    programme() {
      return JSON.parse(atob(this.$route.params.prog)).prog;
    },
    rules() {
      return {
        phone: [
          (v) => !!v || "Phone Number is required",
          (v) =>
            /^\+(?:[0-9] ?){6,14}[0-9]$/.test(v) ||
            "Provide valid phone number",
        ],
        id_number: [
          (v) => !!v || "ID Number is required",
          (v) => /^[0-9]*$/.test(v) || "Please enter a valid ID/ passport No",
        ],
        email: [
          (v) => !!v || "E-mail is required",
          (v) =>
            /^([A-Za-z0-9_\-.])+@([A-Za-z0-9_\-.])+\.([A-Za-z]{2,4})$/.test(
              v,
            ) || "E-mail must be valid",
        ],
        pwdRules: [
          (v) => !!v || "Password required",
          (v) =>
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#~^()`.,;:{}_/%*?&])[A-Za-z\d@$!#~^()`.,;:{}_/%*?&]{8,16}$/.test(
              v,
            ) ||
            "Password should contain: Minimum 8 and maximum 16 characters, at least one uppercase letter, one lowercase letter, one number and at least one special character(@$!#~^()`.,;:{}_/%*?&)",
        ],
        pwdConfirm: [
          (v) => !!v || "Confirm password",
          (v) => v === this.formData.password || "Passwords do not match",
        ],
        field: [(v) => !!v || "Field is required"],
      };
    },
  },
  methods: {
    formatMessage(message) {
      return message.split(",");
    },
    signup: function () {
      if (!this.isValid) {
        this.$refs.SignupForm.validate();
      } else {
        const param = JSON.parse(atob(this.$route.params.prog));
        const programme = this.setupProgrammes.filter(
          (prog) => prog.code === param.prog,
        )[0];
        this.formData.programme = programme.code;
        this.$store.dispatch("Auth/applicationRegistration", {
          ...this.formData,
        });
      }
    },
    checkPassword() {
      this.password_length = this.formData.password.length;
      const format = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;

      if (this.password_length > 8) {
        this.contains_eight_characters = true;
      } else {
        this.contains_eight_characters = false;
      }
      if (this.password_length > 8 && this.password_length < 16) {
        this.contains_max_sixteen_characters = true;
      } else {
        this.contains_max_sixteen_characters = false;
      }

      this.contains_number = /\d/.test(this.formData.password);
      this.contains_uppercase = /[A-Z]/.test(this.formData.password);
      this.contains_lowercase = /[a-z]/.test(this.formData.password);
      this.contains_special_character = format.test(this.formData.password);

      if (
        this.contains_eight_characters === true &&
        this.contains_special_character === true &&
        this.contains_uppercase === true &&
        this.contains_number === true
      ) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
    },
    onPasswordChange(value) {
      const myInput = value;
      console.log(myInput);
      myInput.onpaste = (e) => e.preventDefault();
    },
  },
};
</script>
<style scoped>
@import url("../styles/signup.css");
.signup-info-white {
  background-image: url("../../../assets/images/bg.png");
  background-position: center;
  background-repeat: repeat;
  font-family: "PT Sans Caption", sans-serif;
}
.sign-up-instructions {
  background-image: url("../../../assets/images/kiseb-poster.jpg");
  background-position: center;
  background-repeat: repeat;
  background-size: cover;
  font-family: "PT Sans Caption", sans-serif;
}

.signup--form {
  max-width: 100%;
}
.sign-up-button {
  background: #1161ee;
  border: none;
  padding: 15px 20px;
  border-radius: 25px;
  background: rgba(255, 255, 255, 0.1);
  text-transform: uppercase;
}
@media (min-width: 1450px) {
  .signup--form {
    max-width: 90%;
  }
}
/** Hide and display images*/
.eligibility-poster {
  display: none;
}
@media only screen and (max-width: 480px) {
  .column-poster {
    background: none !important;
  }
  .eligibility-poster {
    display: block;
  }
  .logo {
    display: none;
  }
  .divider {
    display: none;
  }
}
</style>
